export default "__VITE_ASSET__Cum78kXK__"